<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card :loading="loading" class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline"
          >{{ originalScreen ? "Editar" : "Agregar" }} pantalla</span
        >
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col v-if="!originalScreen" cols="12" sm="12" md="12">
              <v-text-field
                v-model="code"
                label="Código de la pantalla"
                autofocus
                rounded
                ref="code"
                filled
                clearable
                v-on:keyup.enter="search"
              ></v-text-field>
            </v-col>

            <v-col v-if="result || originalScreen" cols="12" sm="12" md="12">
              <v-text-field
                v-model="screen.name"
                label="Nombre de la pantalla"
                rounded
                filled
                :loading="loading"
                clearable
              ></v-text-field>
            </v-col>

            <v-col v-if="result || originalScreen" cols="12" sm="12" md="12">
              <v-text-field
                v-model="screen.description"
                label="Descripción"
                rounded
                filled
                :loading="loading"
                clearable
              ></v-text-field>
            </v-col>

            <v-col v-if="result || originalScreen" cols="12" sm="12" md="12">
              <v-select
                :items="zones"
                item-text="name"
                rounded
                filled
                item-value="id"
                :loading="loading"
                v-model="screen.zone"
                label="Zona"
                persistent-hint
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="end">
                <v-btn
                  v-if="!result && !originalScreen"
                  :loading="loading"
                  class="save-btn"
                  @click="search()"
                  color="btn-color"
                  >Buscar</v-btn
                >
                <v-btn
                  v-if="result || originalScreen"
                  :loading="loading"
                  @click="originalScreen ? updateScreen() : addScreen()"
                  color="btn-color"
                  >Guardar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";

export default {
  name: "add-screen",
  props: [
    "originalScreen",
    "countries",
    "selectedCountry",
    "selectedCity",
    "selectedAgency",
  ],
  data() {
    return {
      screen: {
        name: "",
        playlist: "",
        country: "",
        city: "",
        agency: "",
      },
      code: "",
      result: null,
      snackbarText: "",
      snackbar: false,
      loading: false,
      zones: [],
      cities: [],
      agencies: [],
    };
  },
  computed: {
    ...mapState(["user", "groupId"]),
  },
  watch: {
    "screen.country"(countryId) {
      this.$binding(
        "cities",
        db.collection("cities").where("country", "==", countryId)
      );
    },
    "screen.city"(cityId) {
      this.$binding(
        "agencies",
        db
          .collection("agencies")
          .where("city", "==", cityId)
          .where("createdBy", "==", this.$store.state.user.uid)
      );
    },
  },

  methods: {
    sortedArray: function () {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.zones.sort(compare);
    },
    search() {
      if (this.code) {
        this.loading = true;
        db.collection("tempScreens")
          .where("code", "==", parseInt(this.code))
          .get()
          .then((response) => {
            if (response.size == 0) {
              this.snackbarText = `No se encontró ninguna pantalla asociada al código ${this.code}`;
              this.snackbar = true;
            } else {
              if (response.docs[0].data().uuid) {
                this.result = response.docs[0].data();
                this.result.id = response.docs[0].id;
              } else {
                this.snackbarText =
                  "La pantalla encontrada no tiene los campos requeridos, inténtelo nuevamente.";
                this.snackbar = true;
              }
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      } else {
        this.snackbarText = "Ingrese el código que se muestra en la pantalla";
        this.snackbar = true;
      }
    },
    updateScreen() {
      if (
        this.screen.name &&
        this.screen.zone &&
        this.screen.country &&
        this.screen.city &&
        this.screen.agency
      ) {
        this.loading = true;
        db.collection("screens")
          .doc(this.originalScreen[".key"])
          .update({
            name: this.screen.name,
            zone: this.screen.zone,
            modifiedAt: new Date(),
            description: this.screen.description ? this.screen.description : "",
            modifiedBy: this.user.uid,
            country: this.screen.country,
            city: this.screen.city,
            agency: this.screen.agency,
          })
          .then(async (response) => {
            this.loading = false;
            this.$emit("success");
          })
          .catch((error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText =
          "Ingrese un nombre y seleccione una lista de reproducción.";
        this.snackbar = true;
      }
    },
    addScreen() {
      if (this.result && this.screen.name && this.screen.zone) {
        this.loading = true;
        db.collection("screens")
          .add({
            name: this.screen.name,
            description: this.screen.description ? this.screen.description : "",
            zone: this.screen.zone,
            createdAt: new Date(),
            createdBy: this.user.uid,
            country: this.selectedCountry,
            city: this.selectedCity,
            agency: this.selectedAgency,
            selectedApp: "zones",
            active: true,
            uuid: this.result.uuid,
            groupId: this.groupId,
          })
          .then(async (response) => {
            this.loading = false;
            await db.collection("tempScreens").doc(this.result.id).update({
              configured: true,
            });
            this.$emit("success");
          })
          .catch((error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Ingrese todos los campos.";
        this.snackbar = true;
      }
    },
  },
  async mounted() {
    let groupId = this.$store.state.groupId;
    this.loading = true;
    await db
      .collection("zones")
      .where("groupId", "==", groupId)
      .get()
      .then((response) => {
        response.forEach((item) => {
          let zone = item.data();
          zone.id = item.id;
          this.zones.push(zone);
        });

        this.zones = this.sortedArray();
        this.loading = false;
      });

    if (this.originalScreen) {
      this.screen = Object.assign({}, this.originalScreen);
    }
  },
};
</script>